import React from 'react'

import './IconCounter.scss'

interface Props {
    counter: number,
}

interface State {
    adding: boolean
}

export default class IconCounter extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            adding: false
        }
    }

    public getSnapshotBeforeUpdate(prevProps: any, prevState: State) {
        // Are we adding new items to the list?
        if (prevProps.counter !== this.props.counter) {
            return prevProps.counter
        }
        return null
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        if (snapshot && snapshot !== this.props.counter && !prevState.adding) {
            this.setState({ adding: true })
            setTimeout(() => this.setState({ adding: false }), 1000)
        }
    }

    public render() {

        const { counter, children } = this.props

        return(
            <div className="icon-container">
                {children}
                { counter > 0 ? (
                    <React.Fragment>
                        <div
                            className={this.state.adding ?
                                'icon-container__counter animate' :
                                'icon-container__counter'}
                        >
                            {this.state.adding ? counter - 1 : counter}
                        </div>
                        <div
                            className={this.state.adding ?
                                'icon-container__animation animate'
                                : 'icon-container__animation'}
                        >
                            {counter}
                        </div>
                    </React.Fragment>
                ) : (
                    null
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/IconCounter/index.tsx